<template>
  <div
    class="feedback"
    v-if="
      [
        'data-query',
        'chart-production',
        'comparison-analysis',
        'illegal-spots',
        'certificate-manage'
      ].indexOf(path) !== -1
    "
    @click="showModal"
  >
    <img src="@/assets/images/feedback.png" alt="" />
    <span>反馈</span>

    <a-modal
      class="feedbck-modal"
      title="意见反馈"
      :footer="null"
      :visible="visible"
      :centered="true"
      :destroyOnClose="true"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="标题" prop="tel">
          <a-input v-model="form.tel" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item label="反馈类型" prop="category">
          <a-select
            v-model="form.category"
            placeholder="请选择反馈类型"
            dropdownClassName="front-page"
          >
            <a-select-option :value="1">
              新增养殖
            </a-select-option>
            <a-select-option :value="2">
              退出养殖
            </a-select-option>
            <a-select-option :value="3">
              沟通咨询
            </a-select-option>
            <a-select-option :value="4">
              其他
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="电子邮箱" prop="email">
          <a-input v-model="form.email" placeholder="请输入电子邮箱" />
        </a-form-model-item>
        <a-form-model-item label="链接" prop="remark">
          <a-input v-model="form.remark" placeholder="请输入链接" />
        </a-form-model-item>
        <a-form-model-item label="反馈内容" class="feeback-textarea" prop="content">
          <a-input v-model="form.content" type="textarea" placeholder="请输入反馈内容" />
        </a-form-model-item>
        <a-form-model-item label="附件">
          <a-upload
            class="upload-file"
            action="#"
            :file-liist="uploadedFileList"
            :customRequest="uploadFiles"
            accept=".txt,.ppt,.pptx,.pdf,.doc,.docx,image/jpeg,image/jpg,image/png,video/mp4,.mp3,.xlsx,.xls"
            :before-upload="beforeUpload"
            :remove="handleFileRemove"
          >
            <a-button> <a-icon type="upload" /> 上传 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
      <div class="send">
        <a-button type="primary" @click="userFeedback">
          发送
        </a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      const regEmail = /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
      if (!regEmail.test(value)) {
        callback(new Error('请输入正确的邮箱'))
      } else {
        callback()
      }
    }
    return {
      currentPath: ['', '', ''],
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {
        tel: '', // 标题
        category: undefined, // 反馈类型
        content: '', // 反馈内容
        email: '', // 电子邮箱
        remark: '', // 链接
        picUrls: [] // 附件
      },
      uploadedFileList: [],
      rules: {
        // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' }
        tel: [{ required: true, message: '请输入标题', trigger: 'blur', whitespace: true }],
        category: [{ required: true, message: '请选择反馈类型', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur', whitespace: true },
          { validator: validateEmail, trigger: 'blur' }
        ],
        content: [{ required: true, message: '请输入反馈内容', trigger: 'blur', whitespace: true }]
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {
    userFeedback() {
      this.$refs.form.validate(valid => {
        if (valid) {
          $http
            .UserFeedback({
              data: {
                tel: this.form.tel, // 标题
                category: this.form.category, // 反馈类型
                content: this.form.content, // 反馈内容
                email: this.form.email, // 链接
                picUrls: this.form.picUrls.join(',') // 附件
              }
            })
            .then(res => {
              this.$message.success('发送成功')
              this.$refs.form.resetFields()
              this.picUrls = []
              this.visible = false
            })
            .catch(() => {
              this.$message.error('发送失败')
            })
        }
      })
    },
    uploadFiles(info) {
      const fileInfo = {
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        response: '',
        url: ''
      }
      const formData = new FormData()
      formData.append('multipartFiles', info.file)
      $http
        .FileUpload({
          data: formData
        })
        .then(res => {
          fileInfo.status = 'done'
          fileInfo.url = res.data.data[0].url
          this.uploadedFileList.push(fileInfo)
          // this.form.picUrls.push(res.data.data[0].url)
          this.form.picUrls.push(res.data.data[0].url)
          this.$message.success('上传成功！')

          info.onSuccess(res.data, info)
        })
        .catch(err => {
          fileInfo.status = 'error'
          info.onError(err)
        })
    },
    handleFileRemove(file) {
      const findFileIdx = this.uploadedFileList.findIndex(item => {
        return file.uid === item.uid
      })
      this.uploadedFileList.splice(findFileIdx, 1)
      this.form.picUrls.splice(findFileIdx, 1)
    },
    beforeUpload(file, fileList) {
      const fileType = file.name.split('.')
      if (
        [
          'txt',
          'ppt',
          'pptx',
          'pdf',
          'doc',
          'docx',
          'jpeg',
          'jpg',
          'png',
          'mp4',
          'mp3',
          'xlsx',
          'xls'
        ].indexOf(fileType.slice(-1)[0]) < 0
      ) {
        const index = fileList.findIndex(item => {
          return item.uid === file.uid
        })
        fileList.splice(index, 1)
        this.$message.error(`${fileType}类型文件暂不支持!`)
        return false
      }
    },
    showModal() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.form.picUrls = []
      })
    },
    onSubmit() {},
    handleOk() {},
    handleCancel() {
      this.$refs.form.resetFields()
      this.form.picUrls = []
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.feedbck-modal {
  .ant-modal {
    width: 587px !important;
  }
  .ant-modal-content {
    width: 587px;
    min-height: 610px;
    border-radius: 10px;

    .ant-form-item {
      margin-bottom: 16px;

      .ant-form-item-control {
        line-height: 0;
      }

      .ant-form-explain {
        min-height: 0;
        height: 0;
        padding: 5px 0;
        line-height: 16px;
      }
    }

    .ant-modal-body {
      padding-bottom: 80px;

      .ant-form-item-label {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #083307;
      }

      .ant-input {
        padding: 4px 11px;
        font-size: 14px;
        height: 40px;
        border: none;
        border-radius: 4px;
        background: rgba(133, 157, 133, 0.12);
      }

      .ant-select-selection {
        height: 40px;
        border: none;
        border-radius: 4px;
        background: rgba(133, 157, 133, 0.12);

        .ant-select-selection__rendered {
          height: 40px;

          .ant-select-selection-selected-value {
            line-height: 40px;
          }
        }

        .ant-select-arrow {
          color: #7d8e7d;
        }
      }

      .feeback-textarea {
        .ant-input {
          height: 128px;
          resize: none;
        }
      }

      .upload-file {
        .ant-btn {
          width: 135px;
          height: 40px;
          border: none;
          border-radius: 4px;
          background: rgba(5, 193, 96, 0.39);

          font-size: 16px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #009146;
        }
      }
    }
  }

  .ant-modal-header {
    border-radius: 10px 10px 0 0;
  }

  .ant-modal-title {
    font-size: 18px;
    font-family: 微软简综艺-Regular, 微软简综艺;
    font-weight: 400;
    color: #083307;
    text-align: center;
  }

  .send {
    position: absolute;
    bottom: 32px;
    right: 24px;
    // left: 50%;
    // transform: translateX(-50%);

    .ant-btn {
      width: 108px;
      height: 40px;
      background: #05c160;
      border: none;
      border-radius: 4px 4px 4px 4px;

      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>

<style lang="scss" scoped>
.feedback {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 800;
  top: 23px;
  right: 75px;
  img {
    width: 12px;
    height: 15px;
  }
  cursor: pointer;
  span {
    margin-left: 5px;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
}
@media screen and (max-width: 740px) {
  .feedback {
    display: none;
  }
}
</style>
